import { InjectionToken } from '@angular/core';

export interface RestConfig {
	apiBasePath?: string;
}

export const REST_CONFIG = new InjectionToken<RestConfig>('rest.config');